// src/utils/preload.js
// Utility to preload product images
import addClass from './dom/addClass';

const preload = (images) => {
  let loading = 0;
  const total = images.length;

  const doPreload = () => {
    if (loading === total) {
      return;
    }
    addClass(images[loading].querySelector('img'), 'lazypreload');
    loading = loading + 1;
    doPreload();
  };

  doPreload();
};

export default preload;
